import { render, staticRenderFns } from "./SalDispatchListDetail.vue?vue&type=template&id=332ea180&scoped=true&"
import script from "./SalDispatchListDetail.vue?vue&type=script&lang=js&"
export * from "./SalDispatchListDetail.vue?vue&type=script&lang=js&"
import style0 from "./SalDispatchListDetail.vue?vue&type=style&index=0&id=332ea180&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332ea180",
  null
  
)

export default component.exports